import * as ClipLayout from 'show-page/constants/clip-layout';
import GridIcon from 'common/components/svg-icon/grid';
import ListIcon from 'common/components/svg-icon/list';
import styles from './styles.less';
import { observer } from 'mobx-react';


function ClipLayoutMenu(props) {
    return (
        <div className={ cx(styles.root, props.className) }>
            <button
                className={ cx(styles.button, { [styles.selected]: props.currentLayout === ClipLayout.GRID }) }
                onClick={ () => props.onLayoutSelect(ClipLayout.GRID) }>
                <GridIcon
                    className={ styles.icon }
                    height='28'
                    width='28'
                />
            </button>
            <button
                className={ cx(styles.button, { [styles.selected]: props.currentLayout === ClipLayout.LIST }) }
                onClick={ () => props.onLayoutSelect(ClipLayout.LIST) }>
                <ListIcon
                    className={ styles.icon }
                    height='28'
                    width='28'
                />
            </button>
        </div>
    );
}

ClipLayoutMenu.propTypes = {
    currentLayout: React.PropTypes.string,
    onLayoutSelect: React.PropTypes.func.isRequired
};


export default observer(ClipLayoutMenu);



/** WEBPACK FOOTER **
 ** ./src/show-page/components/clip-layout-menu/index.js
 **/